import { cookies } from '~/cookie';

export const setAuthToken = async (value: string) => {
  return cookies.set('session', value);
};

export const getAuthToken = async () => {
  return cookies.get('session');
};
